import Vue from 'vue';

import Vuelidate from 'vuelidate';
import {
  extend,
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate';
import {
  required,
  email,
  min,
  max,
  integer,
} from 'vee-validate/dist/rules';

import { IfacValidInput } from '@ifac/ui';

extend('required', {
  ...required,
  message: 'This field is required',
});

extend('email', {
  ...email,
  message: 'Please provide a valid email address',
});

extend('min', {
  ...min,
  message(fieldName, rule) {
    return `Input not long enough, ${rule.length} characters required`;
  },
});

extend('max', {
  ...max,
  message(fieldName, rule) {
    return `Input is too long, ${rule.length} characters as maximum`;
  },
});

extend('integer', {
  ...integer,
  message() {
    return 'The field must be a number';
  },
});

extend('noOrString', {
  validate: (value) => !value.includes('-OR-'),
  message: 'Please correct the value to use',
});

extend('latinScript', {
  validate: (value) => /^[\u0020-\u024F]*$/.test(String(value ?? '').normalize('NFC')),
  message: 'Please use Latin characters only. Use the "Name in any domestic characters" field for other scripts.',
});

Vue.use(Vuelidate);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('valid-input', IfacValidInput);
